import React, { useContext, useEffect, useState } from 'react';
import { vfsHomeUrl } from 'src/common';
import { IceCreamImage } from 'src/assets/images';
import { SalesforceContext } from 'src/context/salesforce-context';
import NavigationFooter from 'src/components/navigation-footer/navigation-footer';
import { PaymentGatewayContext } from 'src/context/payment-gateway-context';
import { SubmitModal } from 'src/containers/onboarding/confirm-modal/confirm-modal';
import TealiumEvents from 'src/helpers/tealium-events';
import './failure.scss';

export default function Failure() {
  const { merchant, customerType } = useContext(SalesforceContext);
  const { reserveFunds } = useContext(PaymentGatewayContext);
  const [nextEnabled, setNextEnabled] = useState(true);
  const [showCancelModal, setShowCancelModal] = useState(false);


  const [redirect, setRedirect] = useState();

  const handleNext = async () => {
    setNextEnabled(false);
    try {
      await reserveFunds(true);
    } catch (error) {
      setNextEnabled(true);
    }
  };

  const handleCancel = () => {
    setRedirect(vfsHomeUrl);
  };

  useEffect(() => {
    TealiumEvents.reserveFundsFailedPageLoad(merchant?.account?.business_type, customerType);
  }, []);

  if (redirect) {
    window.location.href = redirect;
    return null;
  }

  return (
    <>
      <div className="FailureParent" data-testid="UploadDocuments">
        <div className="FailurePage">
          <div className="has-text-centered">
            <div>
              <div className="ice-cream">
                <img src={IceCreamImage} />
              </div>
              <h1
                className="page-title-failure heading-four has-padding-top-3"
                automationid="Onboarding_Create_Account_Heading_One_Failure_Main_Message"
              >
                Oops! Looks like your payment method failed.
              </h1>
            </div>

            <div>
              <p
                className="has-padding-x-3 has-padding-y-2 wrapping-container has-mobile-padding-x-4 has-text-blue-grey-3 has-mobile-padding-bottom-3 has-mobile-padding-top-5"
                automationid="Onboarding_Create_Account_Paragraph_Failure_Secondary_Message"
              >
                We were unable to reserve your once off payment for you. <br /> Please try again
              </p>

              <div className="once-approved-box wrapping-container has-padding-y-5 has-padding-x-2 has-text-blue-grey-2 has-margin-bottom-1">
                <p>We will reserve the funds and we will only charge once your FICA is approved</p>
              </div>
            </div>
          </div>
        </div>

        <NavigationFooter
          nextButtonLabel="Retry"
          onNext={handleNext}
          hideSaveForLater={true}
          hideBack={true}
          hideCancel={false}
          onCancel={() => setShowCancelModal(true)}
          nextEnabled={nextEnabled}
          automationIdPrefix="Onboarding"
        />
      </div>

      <SubmitModal
        show={showCancelModal}
        title="Are you sure you want to cancel?"
        body={() => <p>You will be able to continue where you left off.</p>}
        footer={() => (
          <>
            <div className="center-items has-padding-x-4">
              <a
                className={'button is-pulled-left'}
                onClick={() => setShowCancelModal(false)}
                automationid={'Onboarding_Button_Confirm_Cancel_Back'}
              >
                Back
              </a>
            </div>
            <div className="center-items has-padding-x-4">
              <a
                className={'button is-primary is-pulled-right'}
                onClick={() => {
                  handleCancel();
                  setShowCancelModal(false);
                }}
                automationid={'Onboarding_Button_Confirm_Cancel_Submit'}
              >
                Confirm
              </a>
            </div>
          </>
        )}
      />
    </>
  );
}
